import React, {useMemo, useState} from "react";
import LoungeHeading from "../../../../components/LoungeHeading";
import Comment from "../../../../components/Comment";
import useCreateComment from "../../../../hooks/forms/useCreateComment";
import {useFormatValidationErrors} from "../../../../hooks/response";
import useFetchComments from "../../../../hooks/useFetchComments";
import useUser from "../../../../hooks/useUser";
import useKeyboard from "../../../../hooks/ui/useKeyboard";
import {toast} from "react-toastify";
import { useTranslation } from "react-i18next";

const PostComment = () => {
  const {t} = useTranslation('lounge')
  const {formik, mutation} = useCreateComment({
    onSuccess: () => {
      toast(t('thank-you-for-message'));
    }
  });
  const {keyboard, onFocus, onBlur} = useKeyboard();

  const errors = useFormatValidationErrors(mutation.error || {}, formik.errors);
  const error = (formik.touched.body && errors.body) || (formik.touched.attachment && errors.attachment);

  const imageUrl = useMemo(() => formik.values.attachment && URL.createObjectURL(formik.values.attachment), [formik.values.attachment]);

  return (
    <div>
      <div className="bg-white rounded-lg mb-2">
        <div className={`relative ${imageUrl ? 'pb-3' : ''}`}>
          <input
            type="text"
            className="w-full pl-4 pr-10 py-3 rounded-lg outline-none"
            placeholder="Leave your message"
            {...formik.getFieldProps('body')}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          <div className="absolute top-0 right-0">
            <label className="custom-file-upload">
              <input
                type="file"
                className="hidden"
                accept="image/*"
                {...formik.getFieldProps('attachment')}
                value={undefined}
                onChange={(event) => {
                  formik.setFieldValue("attachment", event.currentTarget.files[0]);
                }}
              />
              <i className="fas fa-camera fa-fw"></i>
            </label>
          </div>
          {formik.values.attachment && (
            <div className="w-20 h-20 relative mx-4 mt-2">
              <img src={imageUrl} className="w-full h-full object-contain border rounded-lg"></img>
              <button
                className="w-4 h-4 rounded-full bg-black text-white absolute top-1 right-1 flex items-center justify-center"
                disabled={formik.isSubmitting}
                onClick={() => formik.setFieldValue('attachment', false)}
              >
                <i className="fas fa-fw fa-times" style={{fontSize: 10}}/>
              </button>
            </div>
          )}
        </div>
      </div>

      {error && <p className="text-red-500 text-xs">{error}</p>}

      <div className="mt-5 mb-6">
        <button type="submit" className="btn-primary" onClick={formik.handleSubmit} disabled={formik.isSubmitting}>
          {t('leave-message')}
        </button>
      </div>
    </div>
  )
};

const CommentModule = ({page, body}) => {
  const {t} = useTranslation('lounge')
  const user = useUser();
  const {
    status,
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
  } = useFetchComments();

  return (
    <div>
      <LoungeHeading title={page.data?.title}>
        <div className="lounge-body">
          {body}
        </div>
      </LoungeHeading>

      {user && <PostComment />}

      {data?.pages && data.pages.map((i, k) => {
        return i.data.map(item => (
          <Comment
            className="mb-8"
            key={`${item.id}-${k}`}
            name={item.user.name}
            date={item.created_at}
            avatar={item.user.avatar_thumb}
            body={item.body}
            attachment={item?.attachment}
            attachmentPreview={item?.attachment_thumb || item?.attachment}
          />
        ))
      })}

      {(isFetchingNextPage || hasNextPage) && (
        <div className="text-center">
          <button type="button" className="btn btn-block btn-yellow" onClick={fetchNextPage} disabled={isFetchingNextPage}>
            {isFetchingNextPage && <i className="fas fa-fw fa-circle-notch fa-spin"/> } {t('load-more')}
          </button>
        </div>
      )}
    </div>
  )
}

export default CommentModule;


